const downloadBase64Pdf = (base64String, fileName) => {
    const link = document.createElement('a');
    link.href = `data:application/pdf;base64,${base64String}`;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}


export default downloadBase64Pdf;